export const cookieOptanononSettingConfig = () => {
    const CookieOptanonSettingEl = document.getElementById('CookieOptanonSetting');
    if (CookieOptanonSettingEl){
        CookieOptanonSettingEl.classList.add('optanon-show-settings');
        CookieOptanonSettingEl.setAttribute('href','javascript:void(0)');
        /*  
            Below logic is added to fix cookie setting link issue. 
            Issue Description: On click of cookie setting link which is in footer section, OT popup should be displayed. This is not happening when first user directly click on it instead of clicking elsewhere on page.
         */
        let isLinkClicked = false;
        CookieOptanonSettingEl.addEventListener('click', (e) => {
            if (!isLinkClicked) {
                e.target.parentElement.click();
                e.target.click();
                isLinkClicked = true;
            }
        });
    }
}